import { useMemo } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { useRichText } from '~/components/RichText/useRichText'
import { BLOCKS } from '@contentful/rich-text-types'
import type { Options as ContentfulRichTextOptions } from '@contentful/rich-text-react-renderer'
import { InfoIcon } from '~/components/icons'
import { TypeCallOut } from '~/types/contentful'
import { Document } from '@contentful/rich-text-types'

type CallOutBoxProps = {
  callOut: TypeCallOut<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const CallOutBox = ({ callOut }: CallOutBoxProps) => {
  const baseOptions = useMemo<ContentfulRichTextOptions>(
    () => ({
      renderNode: {
        [BLOCKS.OL_LIST]: (_, children) => (
          <ol className="list-none p-0  [&>li]:before:[counterIncrement: 'ol-counter'] [counter-reset: ol-counter] [&>li]:before:[content: 'counter(ol-counter) '.']">
            {children}
          </ol>
        ),
        [BLOCKS.UL_LIST]: (_, children) => (
          <ul className="list-none pl-1 mb-0 [&>li]:last:mb-0 [&>li]:mb-20 [&>li]:before:content-none">
            {children}
          </ul>
        ),
        [BLOCKS.LIST_ITEM]: (_, children) => (
          <li className="relative max-md:pl-3  pl-5 [&>p]:text-[19px] before:block before:absolute before:top-0 before:left-0">
            {children}
          </li>
        ),
      },
    }),
    [],
  )

  const { renderOptions } = useRichText({ options: baseOptions })

  const { fields } = callOut
  const { title, description } = fields || {}

  return (
    <div className="flex flex-col rounded-3xl m-12 bg-amber-10 px-7 py-2">
      <div className="text-amber-60 flex gap-2 items-center h-16 border-b border-amber-20">
        <InfoIcon />
        <div className="text-amber-60"></div>
        <div className="text-mobile-s">{title}</div>
      </div>

      <div className="text-[19px]">
        {documentToReactComponents(description as Document, renderOptions)}
      </div>
    </div>
  )
}
